import type { FC, MouseEvent, ReactElement } from "react";
import { Children } from "react";

import { QuickLinksProvider } from "./QuickLinksConfigurationContext/QuickLinksConfigurationContext";
import { QuickLinksGroup } from "./QuickLinksGroup/QuickLinksGroup";

import styles from "./QuickLinks.module.scss";

type QuickLinksProps = {
  onClick?: (ev: MouseEvent<HTMLAnchorElement>) => void;
  children?: ReactElement | ReactElement[];
};

export const QuickLinks: FC<QuickLinksProps> = ({ children, onClick = () => undefined }) => {
  Children.forEach(children, (child) => {
    if (!child) {
      return;
    }

    if (child.type !== QuickLinksGroup) {
      throw new Error("QuickLinks component only accepts QuickLinksGroup components as children");
    }
  });

  return (
    <QuickLinksProvider onClick={onClick}>
      <div data-testid="quicklinks" className={styles.wrapper}>
        {children}
      </div>
    </QuickLinksProvider>
  );
};
